<template>
  <div class="kiw-table">
    <v-card-title class="pa-0">
      <div class="mb-3">
        {{ header }}
      </div>

      <v-btn
        v-if="selectedItems.length"
        depressed
        dense
        color="primary"
        @click="deleteKIWs"
      >
        Usuń zaznaczone wnioski
      </v-btn>
    </v-card-title>
    <v-data-table
      :headers="headers.kiw[this.status]"
      :items="kiwList"
      hide-default-footer
      :loading="isLoading"
      :items-per-page="100"
      class="custom-table mt-6"
    >
      <template #[`item.select`]="{item}">
        <v-simple-checkbox
          :value="isItemSelected(item.id)"
          dense
          :indeterminate="isSelectionDisabled(item)"
          :disabled="isSelectionDisabled(item)"
          color="primary"
          :ripple="false"
          @input="$emit('selectItem', item.id)"
        />
      </template>

      <template #[`item.name`]="{item}">
        <router-link
          class="darken--text underlined-hover"
          :to="{ name: 'kiw-single', params: { id: item.id } }"
        >
          {{ item.name }}
        </router-link>
      </template>

      <template #[`item.updatedAt`]="{ item }">
        {{ item.updatedAt | dateWithTime }}
      </template>

      <template #[`item.number`]="{ item }">
        {{ item.number || item.status }}
      </template>

      <template #no-data>
        <AppEmptyList
          key="emptyList"
          class="py-16"
          header="Brak dostępnych KIW."
          text="Brak dostępnych KIW. <br>
            Zmień w filtrach sposób wyszukiwania."
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import headers from '@/helpers/tableHeaders';
import AppEmptyList from '@/components/UI/AppEmptyList.vue';

export default {
  components: {
    AppEmptyList,
  },

  props: {
    status: {
      type: String,
      required: true,
    },
    kiwList: {
      type: Array,
      required: true,
    },
    header: {
      type: String,
      required: true,
    },
    selectedItems: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      headers,
    };
  },

  computed: {
    ...mapState([
      'isLoading',
    ]),

    ...mapState('auth', [
      'user',
    ]),

    ...mapGetters('auth', [
      'checkUserPermissions',
    ]),

    deletePermitted() {
      const availability = ['admin_director', 'chief', 'guard'];
      return this.checkUserPermissions(availability);
    },
  },

  methods: {
    ...mapActions('kiw', [
      'deleteMultipleKIW',
    ]),

    deleteKIWs() {
      this.deleteMultipleKIW(this.selectedItems)
        .then(() => {
          this.$emit('clearList');
        });
    },

    isItemSelected(id) {
      return this.selectedItems.includes(id);
    },

    isSelectionDisabled(kiw) {
      return !this.deletePermitted && kiw.userId !== this.user.id;
    },
  },
};
</script>

<style lang="scss" scoped>
.kiw-table {
  min-height: 500px;
}
</style>
